import { useActiveChatId } from '../../features/chat/chatSlice';
import { sendbird } from '../client/sendbird';
import { useChatErrorHandlers } from './useChatErrorHandlers';

export const useSendbirdMessaging = () => {
    const activeChannelId = useActiveChatId();
    const { handleError } = useChatErrorHandlers();

    const sendMessage = async (message: string) => {
        try {
            const channel = activeChannelId ? await sendbird.groupChannel.getChannel(activeChannelId) : null;
            channel?.sendUserMessage({
                message,
            });
        } catch (error) {
            handleError(error);
        }
    };

    const markMessagesAsRead = async () => {
        try {
            const channel = activeChannelId ? await sendbird.groupChannel.getChannel(activeChannelId) : null;
            await channel?.markAsRead();
        } catch (error) {
            // Error handling disabled on purpose.Marking messages as read is a fire and forget operation.
        }
    };

    return {
        sendMessage,
        markMessagesAsRead,
    };
};
